// IL LUCCHETTO DI UNA COSA DELLA SCENA — che cosa vuol dire, e dove sta scritto.
//
// VUOL DIRE «NON DAL PALCO» (colleghi, 2026-09-09): una cosa bloccata non si sceglie cliccandola
// nella scena e non si trasforma; si sceglie soltanto dall'elenco, dove chi la cerca sa già di
// cercarla. Serve a chi ha finito di posizionare qualcosa e non vuole spostarlo per sbaglio
// mentre lavora su ciò che gli sta accanto.
//
// PER LE MESH IL BLOCCO È VERO: `isPickable = false` toglie la mesh al raccoglitore di clic di
// Babylon, quindi non arriva l'evento di selezione e con esso non arriva il gizmo. Luci e camere
// oggi in scena non si possono cliccare — non hanno un segno da prendere (voce 26) — quindi lì il
// lucchetto è uno stato DICHIARATO: spegne i campi delle trasformate nel pannello, e sarà già al
// suo posto il giorno che diventeranno selezionabili.
//
// STA NEI METADATA DELLA SCENA, con la stessa forma delle anteprime dei materiali
// (`materialPreview.ts`) e dei gruppi che il 3D core ci tiene già: una mappa per id. È l'unico
// posto disponibile — `SceneCameraLocation` ha sette campi e non se ne aggiungono — ed è anche
// quello giusto, perché i metadata viaggiano dentro il modello che il salvataggio riesporta: il
// lucchetto sopravvive al ricaricamento senza toccare né lo schema né il core.

const LOCKS_KEY = 'lockedNodes';

const lockStore = (sceneEditor: any, create = false): Record<string, boolean> | null => {
    const scene = sceneEditor?.scene;
    if (!scene) return null;

    if (!scene.metadata) {
        if (!create) return null;
        scene.metadata = {};
    }

    if (!scene.metadata[LOCKS_KEY]) {
        if (!create) return null;
        scene.metadata[LOCKS_KEY] = {};
    }

    return scene.metadata[LOCKS_KEY];
};

/** Se questa cosa è bloccata. `id` è quello con cui la scena la conosce, non quello della riga. */
export const isSceneNodeLocked = (sceneEditor: any, id?: string | null): boolean => Boolean(id && lockStore(sceneEditor)?.[id]);

/**
 * Blocca o sblocca. Per una mesh scrive anche `isPickable`, che è il blocco vero; per tutto il
 * resto resta lo stato, che è quello che il pannello legge.
 *
 * Si toglie invece di scrivere `false`: una mappa che ricorda tutto ciò che NON è bloccato cresce
 * con la scena e non dice niente in più.
 */
export const setSceneNodeLocked = (sceneEditor: any, id: string, locked: boolean): void => {
    const store = lockStore(sceneEditor, true);
    if (!store || !id) return;

    if (locked) store[id] = true;
    else delete store[id];

    const mesh = sceneEditor?.scene?.getMeshByID?.(id) ?? sceneEditor?.scene?.getMeshById?.(id);
    if (mesh) mesh.isPickable = !locked;
};

/**
 * Rimette `isPickable` d'accordo con ciò che era stato bloccato. Serve dopo un caricamento: i
 * metadata tornano dal modello, le mesh no — nascono pescabili come tutte le altre.
 */
export const applySceneLocks = (sceneEditor: any): void => {
    const store = lockStore(sceneEditor);
    if (!store) return;

    Object.keys(store).forEach((id) => {
        const mesh = sceneEditor?.scene?.getMeshByID?.(id) ?? sceneEditor?.scene?.getMeshById?.(id);
        if (mesh) mesh.isPickable = false;
    });
};
